import {
  _convertPropertyValuesToArray,
  AbstractEntity,
  logComputeFunction,
  ParamsByNames,
  PlethoraLib,
  PropertyValuesDictionary,
  Transaction,
  UiData,
} from "plethora-lib"
import { AbstractUiEntity } from "../UiClasses/AbstractUiEntity"
import { DataTypeShapeType, DataTypeDirection, DataTypeSize, DataTypeColor } from "./GeneratedDataTypes"

export interface ILoopPropertiesValues {
  TotalIterations: number
  CurrentIteration: number
}

export abstract class GeneratedLoop extends AbstractUiEntity {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super("Loop", id, propertyValues, [], uiData)
  }

  public computeFunction(propertyName: string, functionParameters: ParamsByNames, uiData: UiData): number {
    let result: number
    switch (propertyName) {
      default:
        throw new Error("Error on computeFunction(), unknown computed property name " + propertyName)
    }
    if (typeof result !== "number") {
      throw new Error("Error on computeFunction(), result is not a number")
    }
    logComputeFunction(this.id, this.name, propertyName, functionParameters, uiData, result)
    return result
  }

  protected onPropertyUpdate(propertyName: string, newValue: any, oldValue: any, uiData: UiData): void {
    super.onPropertyUpdate(propertyName, newValue, oldValue, uiData)
    switch (propertyName) {
      case "TotalIterations": {
        this.onTotalIterationsUpdate(newValue, oldValue, uiData)
        return
      }

      case "CurrentIteration": {
        this.onCurrentIterationUpdate(newValue, oldValue, uiData)
        return
      }

      default:
        throw new Error("Unkown property " + propertyName)
    }
  }

  public getTotalIterations(): number {
    return this.getPropertyValue("TotalIterations") as number
  }

  public setTotalIterations(value: number, uiData: UiData = null): void {
    this.setPropertyValue("TotalIterations", value, uiData, true, null)
  }
  public transactionSetTotalIterations(transaction: Transaction, value: number, uiData: UiData = null): void {
    this.setPropertyValue("TotalIterations", value, uiData, true, transaction)
  }

  protected abstract onTotalIterationsUpdate(newValue: number, oldValue: number, uiData: UiData): void

  public getCurrentIteration(): number {
    return this.getPropertyValue("CurrentIteration") as number
  }

  public setCurrentIteration(value: number, uiData: UiData = null): void {
    this.setPropertyValue("CurrentIteration", value, uiData, true, null)
  }
  public transactionSetCurrentIteration(transaction: Transaction, value: number, uiData: UiData = null): void {
    this.setPropertyValue("CurrentIteration", value, uiData, true, transaction)
  }

  protected abstract onCurrentIterationUpdate(newValue: number, oldValue: number, uiData: UiData): void

  protected onAction(actionName: string, actionParameters: ParamsByNames, uiData: UiData): void {
    super.onAction(actionName, actionParameters, uiData)
    switch (actionName) {
      default:
        throw new Error("Unkown action " + actionName)
    }
  }

  protected onInteraction(
    interactionName: string,
    reactorEntity: AbstractEntity,
    interactionParameters: ParamsByNames,
    uiData: UiData
  ): void {
    super.onInteraction(interactionName, reactorEntity, interactionParameters, uiData)
    switch (interactionName) {
      default:
        throw new Error("Unkown interaction " + interactionName)
    }
  }

  public static createRequest(
    propertyValues: Partial<ILoopPropertiesValues>,
    quantity: number,
    uiData: UiData = null
  ): void {
    PlethoraLib.getInstance()
      .getMessagesManager()
      .sendCreateRequestMessage(
        {
          entityName: "Loop",
          properties: _convertPropertyValuesToArray(propertyValues),
          quantity,
        },
        uiData
      )
  }
}
